import React from 'react'
import './Aboutui.css'
import aboutimage from '../Images/aboutimage.png'
function Aboutui() {
    return (
        <div id='aboutui'>
            <div className="section">
                <div className="container">
                    <div className="aboutleft">
                        <img src={aboutimage} alt="aboutimage" />
                    </div>
                    <div className="aboutright">
                        <div className="aboutrightcontent">

                            {/* <h3 className="blueheading">
                                About our work
                            </h3> */}
                            <h1 className="heading">
                               Our Approach to Custom Website Design Services
                            </h1>
                            <p className="newpara">
                          Our team of UI/UX strategists, product designers, and interface experts ensures your digital product isn’t just visually appealing - it delivers measurable results. We follow a user-first approach, conducting deep research and usability testing to make data-backed design decisions that truly resonate with your audience.
  </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Aboutui